import {jsonMember, jsonObject} from "typedjson";

@jsonObject()
export class DxControlPointChainGeneration {

  @jsonMember({constructor: Date, isRequired: true})
  baseDate: Date;

  @jsonMember({constructor: Object, isRequired: true})
  businessObject: {id: number, typeId: number};

  @jsonMember({constructor: Number, isRequired: true})
  chainPatternId: number;

  constructor(fields?: Partial<DxControlPointChainGeneration>) {
    if (fields)
      Object.assign(this, fields);
  }
}
